import React from "react";
import IconButton from "@material-ui/core/IconButton";

import { apollo_useStyles } from "../../atom/Apollo_styles";
import Tooltip from "@material-ui/core/Tooltip";
import { affinitycategorylistposeidon_path } from "../../atom/Apollo_links";
import { APOLLO_PROFILE_SYSTEM_ADMIN, APOLLO_SYSTEM_ADMIN, ApolloUserProfileAuth } from "../../atom/Apollo_Authorization";
import { useHistory } from "react-router-dom";

export const SegmentMenu = () => {
  const classes = apollo_useStyles();
  const history = useHistory();

  return (
    <div>
      <ApolloUserProfileAuth role={APOLLO_SYSTEM_ADMIN} profile={APOLLO_PROFILE_SYSTEM_ADMIN}>
        <Tooltip title="アフィニティカテゴリ登録" placement="bottom">
          <IconButton
            aria-label="more"
            color="inherit"
            style={{ paddingTop: "9px", paddingLeft: "8px" }}
            onClick={() => history.push(affinitycategorylistposeidon_path)}
          >
            <img
              src={"/img/poseidon/header_segment_gray.png"}
              alt="setting"
              height="32"
              width="32"
            />
          </IconButton>
        </Tooltip>
      </ApolloUserProfileAuth>
    </div>
  );
};
